import { useConfigStore } from "../stores/ConfigStore";
import { useLanguage } from "../stores/LanguageStore";
import { useLeadsStore } from "../stores/LeadsStore";
import { useFlowStore } from "../stores/WorkflowStore";
import { mainAxios as axios } from "./axios";

export const getWorkflows = async (forReseller) => {
  let response = await axios.get(`/workflows`, {
    params: { only_shared_with_reseller_customers: !!forReseller },
  });

  if (response.data.state) {
    let newLists = response.data.workflows.sort((a, b) => b.id - a.id);
    useFlowStore.getState().setWorkflows(newLists);

    let setPrmOptions = useLeadsStore.getState().setWorkflowOptions;
    setPrmOptions([
      {
        label: useLanguage.getState().language.prm.filter_labels.workflow,
        options:
          response.data["workflows"]
            ?.sort((a, b) => b.id - a.id)
            ?.map((x) => ({ ...x, option_name: x["name"] })) || [],
      },
    ]);
  }

  return response;
};

export const createWorkflow = async ({
  name,
  steps,
  sharing,
  tags_ids,
  folder_id,
  auto_remove_responders,
  nurturing,
  is_newsletter,
}) => {
  return axios.post(`/workflows`, {
    name: name,
    steps: steps,
    tags_ids: tags_ids,
    folder_id: folder_id,
    sharing: sharing,
    auto_remove_responders,
    nurturing,
    is_newsletter,
  });
};

export const editWorkflow = async ({
  id,
  name,
  steps,
  sharing,
  tags_ids,
  folder_id,
  archived,
  auto_remove_responders,
  nurturing,
}) => {
  return axios.put(`/workflows/${id}`, {
    name: name,
    steps: steps,
    tags_ids: tags_ids,
    folder_id: folder_id,
    sharing: sharing,
    archived: archived,
    auto_remove_responders,
    nurturing,
  });
};

export const findWorkflow = async (id) => {
  return axios.get(`/workflows/${id}`);
};

export const deleteWorkflow = async ({ id }) => {
  return axios.delete(`/workflows/${id}`);
};

export const copyWorkflow = async ({ id, user_id, with_models }) => {
  if (user_id) {
    return axios.post(`/workflows/${id}/copy/to/${user_id}`, { with_models });
  }
  return axios.post(`/workflows/${id}/copy`);
};

export const programWorkflow = async ({ workflow_id, data }) => {
  return axios.post(`/workflows/${workflow_id}/program`, { ...data });
};

export const editProgrammation = async (
  workflow_id,
  workflow_programmation_id,
  data,
) => {
  return axios.put(
    `/workflows/${workflow_id}/programmation/${workflow_programmation_id}`,
    { ...data },
  );
};

export const findProgrammation = async (
  workflow_id,
  workflow_programmation_id,
) => {
  return axios.get(
    `/workflows/${workflow_id}/programmation/${workflow_programmation_id}`,
  );
};

export const getProgrammations = async (data) => {
  const response = await axios.get("/workflows/programmations", {
    params: {
      options: JSON.stringify(data),
    },
  });
  if (response.data) {
    useConfigStore.getState().setProgrammations(response.data.results);
  }
  return response;
};

export const getWorkflowProgrammations = async (workflow_id) => {
  return axios.get(`/workflows/${workflow_id}/programmations`);
};

export const sendEmail = async ({
  email_account_id,
  recipients,
  cc_recipients,
  subject,
  html,
  text,
  email_signature_id,
  contact_list_id,
  contact_id,
  contact_id_prm,
  reply_id,
  programmation_contact_id,
}) => {
  return axios.post(`/workflows/send/email`, {
    email_account_id,
    recipients,
    cc_recipients,
    subject,
    html,
    text,
    email_signature_id,
    contact_list_id,
    contact_id,
    contact_id_prm,
    reply_id,
    programmation_contact_id,
  });
};

export const sendEmailWithFiles = async (formData) => {
  return axios.post(`/workflows/send/email-with-attachments`, formData, {
    headers: {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const sendLinkedinInvitation = async ({
  contact_id,
  integration_id,
  message,
}) => {
  return axios.post(`/prm/contact/${contact_id}/linkedin/invitation`, {
    integration_id,
    message,
  });
};
export const sendLinkedinMessage = async ({
  contact_id,
  integration_id,
  message,
  file_id,
}) => {
  return axios.post(`/prm/contact/${contact_id}/linkedin/message`, {
    integration_id,
    message,
    file_id,
  });
};
export const sendWorkflowImage = async ({ id, formData }) => {
  return axios.post(`/workflows/${id}/image`, formData, {
    headers: {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
};
